<template>
  <v-autocomplete
    v-model="autocomplete_value"
    :items="items"
    :filter="filter"
    :search-input.sync="search"
    :rules="used_rules"
    auto-select-first
    placeholder="Selecione o(s) item(s)"
    multiple
    hide-selected
    validate-on-blur
    :return-object="true"
    v-bind="$attrs"
  >
    <template v-slot:selection="{ attrs, item, parent, selected }">
      <v-chip
        v-bind="attrs"
        :input-value="selected"
        label
        small
      >
        <span class="pr-2">{{ get_path_last(item.text) }}</span>
        <v-icon small @click="parent.selectItem(item)">x</v-icon>
      </v-chip>
    </template>

    <template v-slot:item="{ item, on, attrs}">
      <v-list-item v-on="on" v-bind="attrs" class="text-left">
        <v-chip light label small :key="item.value">
          {{ item.text }}
        </v-chip>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>
<script>
import { G_SELECTED_CONTEXT, G_SELECTED_GROUP } from '@/store/modules/helpers/getter.type';
import { splitPath } from '@/store/helpers';
import { G_USER_MODULE } from '@/store/modules/helpers/module.type';

const normalize_str = (s) =>
  (s ?? '').toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export default {
  name: "ItemSelect",
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    rules: {
      type: Array,
      require: false,
      default: () => [],
    },
    // Whether or not the `rules` prop should overwrite completely the internal rules.
    overwriteRules: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    internal_rules: [
      v => v?.length > 0 || "Um item deve ser associado.",
      // TODO: Remove this requirement in the future.
      v => v?.length === 1 || "Não há suporte para mais de um item.",
    ],
    search: "",
  }),
  computed: {
    autocomplete_value: {
      get() {
        return this.value.map(v => ({
          text:  v.text,
          value: v.path,
        }))
      },
      set(val) {
        this.search = '';
        this.emit_change(val);
      },
    },
    used_rules() {
      if (this.overwriteRules) return this.rules;
      else return this.join_rules();
    },
    context() {
      const group_id = this.$store.getters[G_SELECTED_GROUP];
      const ctxt_id = this.$store.getters[G_SELECTED_CONTEXT];
      return this.$store.getters[`${G_USER_MODULE}/${group_id}/${ctxt_id}/cached`];
    },
    items() {
      const selected_cat = this.$route.query?.cat;
      const selected_item = this.$route.query?.item;
      const arr = [];

      const ctxt_id = this.$store.getters[G_SELECTED_CONTEXT];

      this.context.categories.forEach(cat => {
        cat.items.forEach(item => {
          // If this item is not in the selected category and item selected by the user,
          // don't add them to the available items.
          if (selected_cat && selected_item && (selected_cat !== cat || selected_item !== item)) {
            return;
          } else if (selected_cat) {
            arr.push({
              text:  `${item.name}`,
              value: `/${ctxt_id}/${cat.id}/${item.id}`,
            });
          } else {
            arr.push({
              text:  `${cat.name}/${item.name}`,
              value: `/${ctxt_id}/${cat.id}/${item.id}`,
            });
          }
        });
      });
      return arr;
    },
  },
  methods: {
    join_rules() {
      return [...this.internal_rules, ...this.rules];
    },
    // TODO: Implement fuzzy search
    filter(item, query, text) {
      // If the user has already selected a category, make filter out other categories.
      if (this.$route.query?.cat && splitPath(item.value)[1] !== this.$route.query.cat) {
        return false;
      }
      if (item.header) return false;

      const text_norm = normalize_str(text);
      const query_norm = normalize_str(query);

      return text_norm.indexOf(query_norm) > -1;
    },
    emit_change(paths) {
      this.$emit("input", paths.map(v => ({
        text: v.text,
        path: v.value,
      })));
    },
    get_path_last(path) {
      let parts = path.split("/");
      if (parts.length > 1) 
        return `../${parts[parts.length - 1]}`;
      else 
        return parts[0];
    },
  }
}
</script>